import { Col, message, PageHeader, Row, Select, Space, Spin, Tabs } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  SelectItem,
  Form,
  FormItem,
  cuentaMask,
  TableItem,
  dineroDisabledMask,
  ButtonItem,
  ErrorItem,
  RangePickerItem,
  InputNumberItem,
  SwitchItem,
} from "../../../../Components/Items";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import moment from "moment";
import "moment/locale/es";
import {
  descargarExcel,
  descargarPdf,
  UMBRAL_ALTO,
  UMBRAL_MEDIO,
} from "./exportarCostosPorInsumo";

moment.locale("es");

const { Option } = Select;
const { TabPane } = Tabs;

const COLOR_ALTO = "#A8071A";
const COLOR_MEDIO = "#D46B08";
const COLOR_NEUTRO = "#595959";
const COLOR_SIN_COMPRA = "#8C8C8C";

/** Un insumo sin costo en el catalogo es el caso mas urgente, no el mas neutro. */
const colorDesviacion = (registro) => {
  if (!registro.fechaUltimaCompra) return COLOR_SIN_COMPRA;
  if (registro.diferenciaPct === null || registro.diferenciaPct === undefined) {
    return COLOR_ALTO;
  }
  const magnitud = Math.abs(registro.diferenciaPct);
  if (magnitud >= UMBRAL_ALTO) return COLOR_ALTO;
  if (magnitud >= UMBRAL_MEDIO) return COLOR_MEDIO;
  return COLOR_NEUTRO;
};

const sorterTexto = (campo) => (a, b) =>
  (a[campo] || "").toString().localeCompare((b[campo] || "").toString());

const sorterNumero = (campo) => (a, b) => (a[campo] || 0) - (b[campo] || 0);

const ETIQUETA_DIRECCION = {
  1: "Solo donde compramos mas caro que el catalogo",
  2: "Solo donde compramos mas barato que el catalogo",
};

/**
 * Reporte Costos Por Insumo.
 *
 * Responde, insumo por insumo, a que precio se compro realmente la ultima vez,
 * a quien, cuando, con que orden de compra, en que moneda y a que tipo de
 * cambio — contra el costo que trae el catalogo.
 *
 * A diferencia de Costo Vs Ultima Compra, que arranca en los movimientos y por
 * eso solo puede listar insumos que ya tienen compra, este arranca en el
 * catalogo: los insumos SIN ninguna compra tambien salen, marcados "Sin
 * compra". Son justo los que hay que revisar a mano, porque su costo viene de
 * una captura sin respaldo.
 *
 * La tabla en pantalla muestra lo esencial; el Excel trae las 32 columnas del
 * layout completo (moneda original, tipo de cambio, factor de conversion,
 * gastos de importacion, penultima compra y la bitacora del costo).
 */
class ReporteCostosPorInsumo extends Component {
  state = {
    loading: false,
    datos: [],
    resumen: {},
    bloquearCosto: false,
    consultado: false,
    filtros: {},
    objetoProyectos: null,
    objetoUnidadesDeNegocio: null,
    objetoFamilias: null,
    objetoMarcas: null,
    objetoProveedores: null,
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    // Cada catalogo lleva su propio `.catch()`: sin el, uno que falle rechaza
    // el Promise.all y la pantalla se queda con el spinner puesto. Un filtro
    // sin catalogo es una degradacion aceptable; una pantalla colgada no.
    await Promise.all([
      axios
        .post(
          "proyectos/selectProyectos",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status !== 404) {
            this.setState({
              objetoProyectos: res.data.map((value) => (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              )),
            });
          }
        })
        .catch(() => {
          message.error("No se pudo cargar el catalogo de proyectos");
        }),
      axios
        .post(
          "unidadesdenegocio/selectUnidadesDeNegocio",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status !== 404) {
            this.setState({
              objetoUnidadesDeNegocio: res.data.map((value) => (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(
                    value.nivel1 +
                    value.nivel2 +
                    value.nivel3 +
                    value.nivel4 +
                    value.nivel5
                  ) +
                    " - " +
                    value.nombre}
                </Option>
              )),
            });
          }
        })
        .catch(() => {
          message.error("No se pudo cargar el catalogo de unidades de negocio");
        }),
      axios
        .post(
          "familias/selectFamilias",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status !== 404) {
            this.setState({
              objetoFamilias: res.data.map((value) => (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              )),
            });
          }
        })
        .catch(() => {
          message.error("No se pudo cargar el catalogo de familias");
        }),
      axios
        .post(
          "marcas/selectTodasMarcas",
          { empresaId: this.props.empresaId, estado: 1 },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.success === 2 && Array.isArray(res.data.marcas)) {
            this.setState({
              objetoMarcas: res.data.marcas.map((value) => (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              )),
            });
          }
        })
        .catch(() => {
          message.error("No se pudo cargar el catalogo de marcas");
        }),
      axios
        .post(
          "proveedores/selectProveedores",
          { empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status !== 404) {
            this.setState({
              objetoProveedores: res.data.map((value) => (
                <Option value={value._id} key={value._id}>
                  {value.stringBuscar}
                </Option>
              )),
            });
          }
        })
        .catch(() => {
          message.error("No se pudo cargar el catalogo de proveedores");
        }),
    ]);
    // A diferencia de los demas reportes, aqui NO se auto-consulta al entrar:
    // este barre el catalogo completo y abrir la pantalla no deberia costar eso.
    this.setState({ loading: false });
  }

  consultarReporte(values = {}) {
    this.setState({ loading: true });
    axios
      .post(
        "reportesDeInventario/reporteCostosPorInsumo",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            loading: false,
            consultado: true,
            datos: res.data.datos || [],
            resumen: res.data.resumen || {},
            bloquearCosto: !!res.data.bloquearCosto,
            filtros: values,
          });
        } else if (res.data.success === 0 && res.data.message) {
          message.error(res.data.message);
          this.setState({ loading: false });
        } else {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        message.error("Error de conexion");
        this.setState({ loading: false });
      });
  }

  descripcionFiltros() {
    const filtros = this.state.filtros || {};
    const partes = [];
    if (filtros.periodo && filtros.periodo[0] && filtros.periodo[1]) {
      partes.push(
        `Compras del ${moment(filtros.periodo[0]).format("DD/MM/YYYY")} al ${moment(
          filtros.periodo[1]
        ).format("DD/MM/YYYY")}`
      );
    } else {
      partes.push("Ultima compra historica");
    }
    if (filtros.filtrarProyecto === 1) {
      partes.push(`${(filtros.proyectos || []).length} proyecto(s)`);
    }
    if (filtros.filtrarProyecto === 2) {
      partes.push("Filtrado por unidad de negocio");
    }
    if (filtros.familias?.length > 0) {
      partes.push(`${filtros.familias.length} familia(s)`);
    }
    if (filtros.marcas?.length > 0) {
      partes.push(`${filtros.marcas.length} marca(s)`);
    }
    if (filtros.proveedores?.length > 0) {
      partes.push(`${filtros.proveedores.length} proveedor(es)`);
    }
    if (filtros.soloConExistencia) partes.push("Solo con existencia");
    if (filtros.soloSinCompra) partes.push("Solo insumos sin compra");
    if (filtros.desviacionMinima) {
      partes.push(`Desviacion minima ${filtros.desviacionMinima}%`);
    }
    if (ETIQUETA_DIRECCION[filtros.direccion]) {
      partes.push(ETIQUETA_DIRECCION[filtros.direccion]);
    }
    return partes.join(" - ");
  }

  parametrosExportacion() {
    return {
      datos: this.state.datos,
      resumen: this.state.resumen,
      empresaNombre: this.props.empresa,
      descripcionFiltros: this.descripcionFiltros(),
    };
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    const columns = [
      {
        title: "Clave",
        dataIndex: "claveInsumo",
        key: "claveInsumo",
        width: "7%",
        sorter: sorterTexto("claveInsumo"),
        buscar: ["claveInsumo", "codigoInsumo"],
        ellipsis: true,
      },
      {
        title: "Descripcion",
        dataIndex: "descripcionInsumo",
        key: "descripcionInsumo",
        width: "15%",
        sorter: sorterTexto("descripcionInsumo"),
        buscar: "descripcionInsumo",
        ellipsis: true,
      },
      {
        title: "Marca",
        dataIndex: "nombreMarca",
        key: "nombreMarca",
        width: "8%",
        sorter: sorterTexto("nombreMarca"),
        buscar: "nombreMarca",
        ellipsis: true,
      },
      {
        title: "Unidad",
        dataIndex: "nombreUnidad",
        key: "nombreUnidad",
        width: "5%",
        ellipsis: true,
      },
      {
        title: "Existencia",
        dataIndex: "existencia",
        key: "existencia",
        width: "6%",
        align: "right",
        sorter: sorterNumero("existencia"),
      },
      {
        title: "Costo Catalogo",
        dataIndex: "costoCatalogo",
        key: "costoCatalogo",
        width: "8%",
        align: "right",
        sorter: sorterNumero("costoCatalogo"),
        render: (value, record) => (
          <span title={`Moneda del insumo: ${record.abreviacionMoneda}`}>
            {dineroDisabledMask(value)}
            {record.abreviacionMoneda && record.abreviacionMoneda !== "MXN"
              ? ` ${record.abreviacionMoneda}`
              : ""}
          </span>
        ),
      },
      {
        title: "Costo Compra",
        dataIndex: "costoUnidadInventarioPesos",
        key: "costoUnidadInventarioPesos",
        width: "8%",
        align: "right",
        sorter: sorterNumero("costoUnidadInventarioPesos"),
        render: (value, record) =>
          value === null || value === undefined ? (
            <span style={{ color: COLOR_SIN_COMPRA }}>-</span>
          ) : (
            <span
              title={
                record.incluyeGastosImportacion === "Si"
                  ? `Con gastos de importacion: ${record.costoConGastosImportacion}`
                  : undefined
              }
            >
              {dineroDisabledMask(value)}
            </span>
          ),
      },
      {
        title: "Diferencia",
        dataIndex: "diferencia",
        key: "diferencia",
        width: "8%",
        align: "right",
        sorter: sorterNumero("diferencia"),
        render: (value, record) =>
          value === null || value === undefined ? (
            <span style={{ color: COLOR_SIN_COMPRA }}>-</span>
          ) : (
            <span style={{ color: colorDesviacion(record), fontWeight: 500 }}>
              {dineroDisabledMask(value)}
            </span>
          ),
      },
      {
        title: "Dif. %",
        dataIndex: "diferenciaPct",
        key: "diferenciaPct",
        width: "6%",
        align: "right",
        // Los de porcentaje nulo (catalogo en 0, o sin compra) se van al tope.
        sorter: (a, b) => {
          if (a.diferenciaPct === null && b.diferenciaPct === null) return 0;
          if (a.diferenciaPct === null) return 1;
          if (b.diferenciaPct === null) return -1;
          return Math.abs(a.diferenciaPct) - Math.abs(b.diferenciaPct);
        },
        render: (value, record) => (
          <span style={{ color: colorDesviacion(record), fontWeight: 500 }}>
            {value === null || value === undefined ? "-" : `${value}%`}
          </span>
        ),
      },
      {
        title: "Ultima Compra",
        dataIndex: "fechaUltimaCompra",
        key: "fechaUltimaCompra",
        width: "8%",
        align: "center",
        sorter: (a, b) =>
          moment(a.fechaUltimaCompra).valueOf() - moment(b.fechaUltimaCompra).valueOf(),
        render: (value) => (value ? moment(value).format("DD/MM/YYYY") : "-"),
      },
      {
        title: "Dias",
        dataIndex: "diasDesdeUltimaCompra",
        key: "diasDesdeUltimaCompra",
        width: "4%",
        align: "right",
        sorter: sorterNumero("diasDesdeUltimaCompra"),
      },
      {
        title: "Proveedor",
        dataIndex: "proveedor",
        key: "proveedor",
        width: "10%",
        sorter: sorterTexto("proveedor"),
        buscar: "proveedor",
        ellipsis: true,
      },
      {
        title: "Documento",
        dataIndex: "documento",
        key: "documento",
        width: "7%",
        buscar: "documento",
        ellipsis: true,
        render: (value) =>
          value === "Sin compra" ? (
            <span style={{ color: COLOR_SIN_COMPRA }}>{value}</span>
          ) : (
            value
          ),
      },
    ];

    const resumen = this.state.resumen || {};

    return (
      <Form
        name="reporteCostosPorInsumo"
        onFinish={this.consultarReporte.bind(this)}
        onFinishFailed={this.onFinishFailed}
      >
        <PageHeader
          onBack={this.atras.bind(this)}
          title={
            "Reporte Costos Por Insumo" +
            (this.state.consultado
              ? `: ${resumen.insumosMostrados || 0} de ${resumen.insumosTotales || 0} insumos`
              : "")
          }
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <div style={{ display: "flex", justifyContent: "right" }}>
              <Space>
                {this.state.datos.length > 0 && (
                  <ButtonItem
                    blanco
                    onClick={() => descargarExcel(this.parametrosExportacion())}
                    icon={<FileExcelOutlined />}
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Descargar Excel
                  </ButtonItem>
                )}
                {this.state.datos.length > 0 && (
                  <ButtonItem
                    blanco
                    onClick={() => descargarPdf(this.parametrosExportacion())}
                    icon={<FilePdfOutlined />}
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Descargar PDF
                  </ButtonItem>
                )}
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  Consultar
                </ButtonItem>
              </Space>
            </div>
          }
        />
        <Spin spinning={this.state.loading}>
          <div
            style={{
              backgroundColor: "white",
              padding: 20,
              paddingTop: 5,
              borderRadius: 5,
              boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
            }}
          >
            <Tabs
              style={{ margin: 0 }}
              tabBarExtraContent={{
                left: <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>Filtros:</h1>,
              }}
            >
              <TabPane tabKey="1" key="1" forceRender tab="Periodo">
                <FormItem
                  marginBottom="0px"
                  label="Periodo de compras"
                  name="periodo"
                  tooltip="Deja este campo vacio para tomar la ultima compra historica de cada insumo. Con un periodo, solo se consideran las compras de ese rango."
                >
                  <RangePickerItem />
                </FormItem>
              </TabPane>
              <TabPane tabKey="2" key="2" forceRender tab="Proyecto">
                <Row>
                  <Col span={8}>
                    <FormItem name="filtrarProyecto" required noStyle initialValue={0}>
                      <SelectItem width="90%" placeholder="Filtrar Proyecto">
                        <Option default value={0}>
                          Niguno
                        </Option>
                        <Option value={1}>Proyectos</Option>
                        <Option value={2}>Unidades de negocio</Option>
                      </SelectItem>
                    </FormItem>
                  </Col>
                  <Col span={8}>
                    <FormItem shouldUpdate noStyle>
                      {({ getFieldValue }) => {
                        const filtrarProyecto = getFieldValue("filtrarProyecto");
                        if (filtrarProyecto === 1) {
                          return (
                            <FormItem required name="proyectos" margin noStyle>
                              <SelectItem
                                width="90%"
                                placeholder="Proyectos"
                                mode="multiple"
                              >
                                {this.state.objetoProyectos}
                              </SelectItem>
                            </FormItem>
                          );
                        }
                        if (filtrarProyecto === 2) {
                          return (
                            <FormItem required margin name="unidadDeNegocioId" noStyle>
                              <SelectItem width="90%" placeholder="Unidades de Negocio">
                                {this.state.objetoUnidadesDeNegocio}
                              </SelectItem>
                            </FormItem>
                          );
                        }
                      }}
                    </FormItem>
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabKey="3" key="3" forceRender tab="Catalogo">
                <Row>
                  <Col span={6}>
                    <FormItem label="Familias" name="familias" margin>
                      <SelectItem width="90%" placeholder="Todas" mode="multiple">
                        {this.state.objetoFamilias}
                      </SelectItem>
                    </FormItem>
                  </Col>
                  <Col span={6}>
                    <FormItem label="Marcas" name="marcas" margin>
                      <SelectItem width="90%" placeholder="Todas" mode="multiple">
                        {this.state.objetoMarcas}
                      </SelectItem>
                    </FormItem>
                  </Col>
                  <Col span={6}>
                    <FormItem
                      label="Proveedores"
                      name="proveedores"
                      margin
                      tooltip="Filtra los insumos que tienen dada de alta una relacion con ese proveedor en su catalogo."
                    >
                      <SelectItem width="90%" placeholder="Todos" mode="multiple">
                        {this.state.objetoProveedores}
                      </SelectItem>
                    </FormItem>
                  </Col>
                  <Col span={3}>
                    <FormItem
                      label="Solo con existencia"
                      name="soloConExistencia"
                      valuePropName="checked"
                      margin
                    >
                      <SwitchItem />
                    </FormItem>
                  </Col>
                  <Col span={3}>
                    <FormItem
                      label="Solo sin compra"
                      name="soloSinCompra"
                      valuePropName="checked"
                      margin
                      tooltip="Deja unicamente los insumos que nunca se han comprado: su costo viene de una captura manual, sin respaldo."
                    >
                      <SwitchItem />
                    </FormItem>
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabKey="4" key="4" forceRender tab="Desviacion">
                <Row>
                  <Col span={8}>
                    <FormItem
                      label="Desviacion minima"
                      name="desviacionMinima"
                      margin
                      tooltip="Solo muestra los insumos donde la diferencia entre el costo del catalogo y la ultima compra es de al menos este porcentaje. Los insumos sin costo en el catalogo se muestran siempre."
                    >
                      <InputNumberItem porcentaje min={0} max={1000} />
                    </FormItem>
                  </Col>
                  <Col span={8}>
                    <FormItem
                      label="Direccion"
                      name="direccion"
                      margin
                      initialValue={0}
                      tooltip="Al elegir una direccion se excluyen los insumos sin compra, porque no hay contra que compararlos."
                    >
                      <SelectItem width="90%" placeholder="Direccion">
                        <Option value={0}>Todas</Option>
                        <Option value={1}>Compramos mas caro</Option>
                        <Option value={2}>Compramos mas barato</Option>
                      </SelectItem>
                    </FormItem>
                  </Col>
                </Row>
              </TabPane>
            </Tabs>
          </div>
          <div style={{ height: 10 }} />
          <div style={{ backgroundColor: "white", padding: 20, borderRadius: 5 }}>
            {this.state.consultado && (
              <p style={{ color: COLOR_NEUTRO, marginBottom: 10 }}>
                {`Sin ninguna compra: ${resumen.sinCompra || 0} - `}
                {`Compramos mas caro que el catalogo: ${resumen.comprandoMasCaro || 0} - `}
                {`Compramos mas barato: ${resumen.comprandoMasBarato || 0} - `}
                {`Desviacion promedio: ${resumen.desviacionPromedio || 0}%`}
                {this.state.bloquearCosto
                  ? " - La empresa tiene el costo bloqueado, asi que las compras no actualizan el costo del catalogo."
                  : ""}
              </p>
            )}
            {!this.state.consultado && !this.state.loading && (
              <p style={{ color: COLOR_NEUTRO, marginBottom: 10 }}>
                Elige los filtros y presiona Consultar. Sin filtros se trae el
                catalogo completo, que puede tardar.
              </p>
            )}
            <TableItem
              size="small"
              dataSource={this.state.datos}
              columns={columns}
              rowKey={(value) => value.insumoId.toString()}
            />
          </div>
        </Spin>
      </Form>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  empresa: state.empresa.nombre,
});

export default connect(mapStateToProps)(ReporteCostosPorInsumo);
